import { Button, Grid } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PlaylistAddIcon from '@material-ui/icons/Tune';
import React, { useCallback } from 'react';
import subscriptionsService from 'v2/services/subscriptions';

const useStyle = makeStyles((theme) => ({
  advancedFilter: {
    paddingTop: theme.spacing(2),
    background: '#ffff',
    borderRadius: 4,
    width: '100%',
  },
  button: {
    color: '#1a2642',
    backgroundColor: '#ffffff',
    borderColor: '#1a2642',
    borderWidth: '1px',
  },
  hr: {
    borderColor: '#1a2642',
    borderWidth: '0.5px',
  },
}));

const AdvancedButton = () => {
  const classes = useStyle({});
  const onOpenAdvanced = useCallback(() => subscriptionsService.setFilterIsAdvanced(true), []);
  return (
    <div className={classes.advancedFilter}>
      <Grid container spacing={1} justify='center' alignItems='center'>
        <Grid item md={4}>
          <hr className={classes.hr} />
        </Grid>
        <Grid item md={4} xs={12}>
          <Button id='advanced-filter-subscriptions-modal-button' className={classes.button} fullWidth variant='outlined' onClick={onOpenAdvanced}>
            <PlaylistAddIcon id='advanced-filter-modal-button' style={{ marginRight: '0.5rem', fontSize: 18 }} />
            <span id='advanced-filter-modal-label'>Filtros Avançados</span>
          </Button>
        </Grid>
        <Grid item md={4}>
          <hr className={classes.hr} />
        </Grid>
      </Grid>
    </div>
  );
};
export default AdvancedButton;
